module.exports = __webpack_public_path__ + "static/media/rectbg.3d3f7d36.png";